import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/**
 * Fetch Multi-Year Trial Balance Comparison Report.
 * @param {number} numYears - Number of years to compare (1 to 5, default 5)
 * @param {string} mode - 'cumulative' or 'annual' (default 'cumulative')
 */
export const getTrialBalanceComparison = async (numYears = 5, mode = "cumulative") => {
  try {
    const response = await axios.get(`${BASE}/reports/trial-balance-comparison`, {
      params: { num_years: numYears, mode },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Trial Balance comparison:", error);
    throw error;
  }
};
